(function () {
    'use strict';

    angular.module("imApp").factory("timeSheetsService", ['$ihttp', function ($ihttp) {
        let service = {
            listMenuTimeSheets: function (parms) {
                return $ihttp.post({
                    method: 123,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
